var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.892 1.42C8.89424 1.39678 8.8998 1.36673 8.8998 1.34146C8.8998 1.15298 8.76045 1 8.58872 1C8.51561 1 8.46423 1.03005 8.44434 1.03859C7.38812 1.49137 3.2998 5.95669 3.2998 9.87803C3.2998 12.7067 5.38923 15 7.96647 15C10.8004 15 12.6331 12.38 12.6331 9.87803C12.6331 5.71663 8.16468 4.94834 8.892 1.42Z",
    fill: "#F56565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotWater);
export default __webpack_public_path__ + "static/media/hot-water.bedfe7e890c6ac14bec88a1d71025f6d.svg";
export { ForwardRef as ReactComponent };